<template>
  <div id="feedback" class="container">
    <div class="bread">试用申请</div>
    <div class="box">
      <div v-show="success0">
        <el-form label-position="right" label-width="130px" style="width:50%;margin:0 auto">
          <el-form-item label="名称:">
            <el-input v-model="title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="货号:">
            <el-input v-model="item_no" placeholder="请输入货号"></el-input>
          </el-form-item>
          <el-form-item label="单位名称:">
            <el-input v-model="works" placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <el-form-item label="收货地址:">
            <el-input v-model="address" placeholder="请输入收货地址"></el-input>
          </el-form-item>
        </el-form>
        <div align="center" style="padding: 30px 0">
          <el-button type="primary" style="width:150px" @click="submit">提交</el-button>
        </div>
      </div>
      <div
        v-show="succees"
        class="container"
        style="background-color:#fff;padding:200px 0;text-align:center"
      >
        <div class="lv0Text" style="font-size:30px;">
          <i class="far fa-check-circle fa-lg"></i>
            试用申请提交成功
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      succees: false,
      success0: true,
      title: "",
      item_no: "",
      works: "",
      address: "",
      options: [
        {
          value: "商品相关"
        },
        {
          value: "物流状况"
        },
        {
          value: "客户服务"
        },
        {
          value: "优惠后的"
        },
        {
          value: "功能异常"
        },
        {
          value: "产品建议"
        },
        {
          value: "其他"
        }
      ],
      src: "",
      codeSrc: ""
    };
  },
  created() {
    
  },
  methods: {
    //

    submit() {
      if (this.title == "") {
        this.$message.error("请输入名称");
        return;
      }
      if (this.item_no == "") {
        return this.$message.error("请输入货号");
      }
      if (this.works == "") {
        return this.$message.error("请输入单位名称");
      }
      if (this.address == "") {
        return this.$message.error("请输入收货地址");
      }
      this.axios
        .get(thsi.serve + "/member/try_use", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            title: this.title,
            item_no: this.item_no,
            works: this.works,
            address: this.address
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.succees = true;
            this.success0 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    preView(e) {
      let files = e.target.files || e.dataTransfer.files;
      var reader = new FileReader();
      var that = this;
      this.form.image = files[0];
      reader.readAsDataURL(this.form.image);
      reader.onload = function(err) {
        var base64Code = this.result;
        that.src = base64Code;
      };
    },
    openFile() {
      this.$refs.file.click();
    }
  }
};
</script>
<style lang="scss">
#feedback {
  .preViewer {
    width: 104.8px;
    height: 104.8px;
    border-radius: 10px;
  }
  padding-bottom: 50px;
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px 20px;
  }
  .place-holder {
    cursor: pointer;
    border: 3px dotted #ddd;
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    text-align: center;
    line-height: 100px;
  }
  .place-holder:hover {
    background-color: #eee;
  }
}
</style>